<full-calendar #fc [options]="calendarOptions"></full-calendar>